import { CissAutoComplete, CissAutoCompleteProps } from './CissAutoComplete';

interface GrupoEconomico {
    idGrupoEconomico: number;
    dsGrupoEconomico: string;
}

type GrupoEconomicoAutoComplete = Pick<CissAutoCompleteProps, 'value' | 'error' | 'multiple' | 'disabled' | 'sx' | 'onChange' | 'name' | 'label'>;

export function GrupoEconomicoAutoComplete({
    label = 'Grupo Econômico',
    value,
    error,
    multiple = true,
    disabled = false,
    sx,
    onChange = () => {},
    name,
}: GrupoEconomicoAutoComplete) {
    return (
        <CissAutoComplete
            objectId="idGrupoEconomico"
            optionStringTemplate="{dsGrupoEconomico}"
            selectedStringTemplate="{dsGrupoEconomico}"
            label={label}
            sx={sx}
            name={name}
            value={value}
            error={error}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            isOptionEqualToValue={(option: GrupoEconomico, value: GrupoEconomico) => option.idGrupoEconomico === value.idGrupoEconomico}
            requestOptions={{
                url: '/gestao/grupoeconomico',
                sort: [{ property: 'idGrupoEconomico', direction: 'ASC' }],
                columns: 'idGrupoEconomico,dsGrupoEconomico',
                nested: true,
                limit: 50,
            }}
        />
    );
}
